import axios from 'axios';

export default {
    login: (payload) => {
        return axios.post("/api/login", payload);
    },
    logout: () => {
        return axios.post("/api/logout");
    },
    getUser: () => {
        return axios.get("/api/user");
    },
    register: (payload) => {
        return axios.post("/api/register", payload);
    },
    checkAuth: () => {
        return axios.get("/api/check-auth");
    },
    uploadRessource: (formData) => {
        return axios.post("/api/ressources/upload", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    deleteRessource: (id) => {
        return axios.delete(`/api/ressources/delete/${id}`);
    },
    getRessources: () => {
        return axios.get("/api/ressources");
    },
    getCompositions: () => {
        return axios.get("/api/compositions");
    },
    uploadComposition: (formData) => {
        return axios.post("/api/compositions/upload", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    deleteComposition: (id) => {
        return axios.delete(`/api/compositions/delete/${id}`);
    },
    uploadTheme: (formData) => {
        return axios.post("/api/themes/upload", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
}